
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-current-affairs/detailed-page/[dateSlug]/[titleSlug]/[id]",
      function () {
        return require("private-next-pages/upsc-current-affairs/detailed-page/[dateSlug]/[titleSlug]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-current-affairs/detailed-page/[dateSlug]/[titleSlug]/[id]"])
      });
    }
  